import { defineMessages } from "react-intl";

export default defineMessages({
  bancontact: {
    id: "payWithBancontact.bancontact",
    defaultMessage: "Bancontact",
  },
});
